module.exports = __webpack_public_path__ + "img/newzeland1.f8ed303e.png";